import { rModelsBase } from './.catalog';

export class rGrupSirketDegerlemeUstBilgi extends rModelsBase {
  gm_toplam: number;
  gs_toplam: number;

  constructor() {
    super();
    this.gm_toplam = 0;
    this.gs_toplam = 0;
  }
}
